import EntityType from '@enums/EntityType';

const BaseEntityType = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_PROPERTY]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_PROPERTY_VALUE]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_TAG]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_TAG_CATEGORY]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_TYPE]: EntityType.ACTIVITY,
  [EntityType.L1_PROCESS]: EntityType.ACTIVITY,
  [EntityType.PROCESS]: EntityType.ACTIVITY,
  [EntityType.GROUP]: EntityType.GROUP,
  [EntityType.GROUP_PROPERTY]: EntityType.GROUP,
  [EntityType.GROUP_PROPERTY_VALUE]: EntityType.GROUP,
  [EntityType.GROUP_TAG]: EntityType.GROUP,
  [EntityType.GROUP_TAG_CATEGORY]: EntityType.GROUP,
  [EntityType.MANAGER]: EntityType.MANAGER,
  [EntityType.PERSON]: EntityType.PERSON,
  [EntityType.PERSON_SKILL]: EntityType.PERSON,
  [EntityType.PERSON_SKILL_LEVEL]: EntityType.PERSON,
  [EntityType.ROLE]: EntityType.ROLE,
  [EntityType.ROLE_PROPERTY]: EntityType.ROLE,
  [EntityType.ROLE_PROPERTY_VALUE]: EntityType.ROLE,
  [EntityType.ROLE_SKILL]: EntityType.ROLE,
  [EntityType.ROLE_SKILL_LEVEL]: EntityType.ROLE,
  [EntityType.ROLE_TAG]: EntityType.ROLE,
  [EntityType.ROLE_TAG_CATEGORY]: EntityType.ROLE,
  [EntityType.ROLE_TYPE]: EntityType.ROLE,
});

export default BaseEntityType;
